import { LoginHandler } from '@local/login';
import { Route, Routes, useRoutes } from 'react-router';

import loginImageHiRes from './assets/login-background-detailed.jpg';
import loginImage from './assets/login-background.jpg';
import { PerformLogin } from './components/login/perform-login';
import Logo from './components/logo/Logo';
import { useImagoMpRoutes } from './hooks/use-imago-mp-routes';
import { LandingPage } from './pages/landing-page';
import { store } from './store/store';
import { ROUTES } from './utils/strings';

const App = () => {
    const { guardedRoutes } = useImagoMpRoutes();
    const imageList = `url(${loginImageHiRes}), url(${loginImage})`;

    const routes = useRoutes([
        {
            path: ROUTES.ROOT_PATH,
            element: <PerformLogin />,
            children: guardedRoutes,
        },
    ]);

    return (
        <Routes>
            <Route
                path="*"
                element={
                    <LoginHandler
                        homePagePath={ROUTES.ROOT_PATH}
                        guardedRoutes={routes}
                        LandingPage={LandingPage}
                        LandingPageLogo={Logo}
                        store={store}
                        service="none"
                        createId={false}
                        imageList={imageList}
                    />
                }
            />
        </Routes>
    );
};

export default App;
